import { useDispatch, useSelector } from 'react-redux';
import { makeGetCompareItems } from '../redux/compare/selectors/CompareSelectors';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import compareActions from '../redux/compare/actions/CompareActions.creators';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
export const useProductTileHelpers = () => {
    const dispatch = useDispatch();
    const compareItems = useSelector(makeGetCompareItems());
    const handleWishlistToggle = (product) => dispatch(wishListActions.toggleProduct(product));
    const handleUpdateCompareList = (product) => dispatch(compareActions.createUpdateOnListerAction(product));
    const handleAddToBasket = (product, analyticsData, location) => dispatch(basketActions.createAddExtensiveTileProductAction(product, location, analyticsData));
    return {
        handleWishlistToggle,
        handleUpdateCompareList,
        handleAddToBasket,
        compareItems,
    };
};
